import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherDetailComment } from "../models/acc-voucher-detail-comment.model";

@Component({
  selector: "ngx-acc-voucher-detail-comment",
  templateUrl: "./acc-voucher-detail-comment.component.html",
  styleUrls: ["./acc-voucher-detail-comment.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccVoucherDetailCommentComponent extends BaseFormComponent<AccVoucherDetailComment> {
  comments: NameValue[];
  @Input() TrsVoucherKindId: number;
  @Input() InvVoucherKindId: number;
  @Input() VoucherKindTitle: string;
  @Input() IsWarehouse: boolean = true;
  currentSeletedColumnKey: string = "Debit";
  rows = 10;
  cols = 50;
  isOkForLoad: boolean;
  erroremessage: string;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "AccVoucherDetailComment";
    this.label = `قالب شرح سند حسابداری (${this.VoucherKindTitle})`;
    this.areaName = "Accounting";

    this.setdefault();
    this.setColumns();
    if (this.TrsVoucherKindId) this.id = this.TrsVoucherKindId;
    if (this.InvVoucherKindId) this.id = this.InvVoucherKindId;

    if (this.id) {
      this.httpCommonService
        .get<AccVoucherDetailComment>(
          this.apiName +
            "/GetByVoucherKindId/" +
            (!this.TrsVoucherKindId ? 0 : this.TrsVoucherKindId) +
            "/" +
            (!this.InvVoucherKindId ? 0 : this.InvVoucherKindId)
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            if (!data) {
              this.newRow();
              this.model.TrsVoucherKindId = this.TrsVoucherKindId;
              this.model.InvVoucherKindId = this.InvVoucherKindId;
              this.setdefault();
            } else {
              this.model = Object.assign({}, data as AccVoucherDetailComment);
              this.setdefault();
              this.setFormGroup(this.model);
            }
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  setdefault() {
    if (this.TrsVoucherKindId) {
      this.comments = [];
      this.comments.push({ Name: "نوع سند", Value: "VoucherKindTitle", Operator: "" });
      this.comments.push({ Name: "شماره سند", Value: "VoucherNo", Operator: "" });
      this.comments.push({ Name: "تاریخ سند", Value: "ShamsiDeliverDate", Operator: "" });
      this.comments.push({ Name: "بابت", Value: "ConcernTitle", Operator: "" });
      this.comments.push({ Name: "تاریخ وصول", Value: "ShamsiDeliverDate", Operator: "" });
      this.comments.push({ Name: "توضیحات هدر سند", Value: "HeaderComment", Operator: "" });
      this.comments.push({ Name: "شرح آرتیکل سند", Value: "DetailComment", Operator: "" });
      this.comments.push({ Name: "تفصیلی طرف مقابل", Value: "DetailLedgerTitle", Operator: "" });
      this.comments.push({ Name: "تفصیلی طرف خزانه", Value: "TreasuryDetailLedgerTitle", Operator: "" });
      this.comments.push({ Name: "شماره پیگیری", Value: "SlaveNo", Operator: "" });
      this.comments.push({ Name: "تحویل گیرنده/دهنده", Value: "Deliverer", Operator: "" });
      this.comments.push({ Name: "شماره مدرک", Value: "DocumentNo", Operator: "" });
      this.comments.push({ Name: "تاریخ مدرک", Value: "ShamsiDocumentDate", Operator: "" });
      this.comments.push({ Name: "بانک", Value: "BankTitle", Operator: "" });
      this.comments.push({ Name: "شماره حساب", Value: "BankAccountNo", Operator: "" });
      this.comments.push({ Name: "کد شعبه", Value: "BankBranchCode", Operator: "" });
      this.comments.push({ Name: "عنوان شعبه", Value: "BankBranchTitle", Operator: "" });
    }
    if (this.InvVoucherKindId) {
      this.comments = [];
      this.comments.push({ Name: "نوع سند", Value: "VoucherKindTitle", Operator: "" });
      this.comments.push({ Name: "شماره سند", Value: "VoucherNo", Operator: "" });
      this.comments.push({ Name: "تاریخ سند", Value: "ShamsiDeliverDate", Operator: "" });
      this.comments.push({ Name: "توضیحات هدر سند", Value: "HeaderComment", Operator: "" });
      this.comments.push({ Name: "شرح آرتیکل سند", Value: "DetailComment", Operator: "" });
      this.comments.push({ Name: "تفصیلی طرف مقابل", Value: "DetailLedgerTitle", Operator: "" });
      this.comments.push({ Name: "شماره پیگیری", Value: "SlaveNo", Operator: "" });
      if (this.IsWarehouse === false) this.comments.push({ Name: "نوع فروش", Value: "SellKindTitle", Operator: "" });
      this.comments.push({ Name: "کد کالا", Value: "GoodsCode", Operator: "" });
      this.comments.push({ Name: "عنوان کالا", Value: "GoodsTitle", Operator: "" });
      this.comments.push({ Name: "انبار", Value: "WarehouseTitle", Operator: "" });
    }
    this.setInputControlValue();
  }

  addControl() {
    this.setValue("DebitCommentFormat", this.model.DebitCommentFormat);
    this.setValue("CreditCommentFormat", this.model.CreditCommentFormat);

    this.setValue("InvVoucherKindId", this.InvVoucherKindId);
    this.setValue("TrsVoucherKindId", this.TrsVoucherKindId);
    this.setInputControlValue();
    this.isOkForLoad = true;
    this.cd.markForCheck();
  }

  private setInputControlValue() {
    if (this.formGroup && this.formGroup.controls["DebitCommentFormat"])
      this.formGroup.controls["DebitCommentFormat"].setValue(this.replaceItemNames(this.model.DebitCommentFormat));
    if (this.formGroup && this.formGroup.controls["CreditCommentFormat"])
      this.formGroup.controls["CreditCommentFormat"].setValue(this.replaceItemNames(this.model.CreditCommentFormat));
  }

  private replaceItemValues(value: string): string {
    this.comments.forEach((t) => {
      value = value.replace(this.wrap(t.Name), t.Value);
    });
    return value;
  }

  private replaceItemNames(value: string): string {
    if (!value) {
      return;
    }
    this.comments
      .sort((a, b) => b.Value.length - a.Value.length)
      .forEach((t) => {
        value = value.replace(t.Value, this.wrap(t.Name));
      });
    return value;
  }

  addItem(name: string, dinput: HTMLTextAreaElement, cinput: HTMLTextAreaElement) {
    const text = this.wrap(name);
    if (this.currentSeletedColumnKey === "Debit") {
      const value = dinput.value;

      const start = dinput.selectionStart;
      const end = dinput.selectionEnd;

      dinput.value = `${value.slice(0, start)}${text}${value.slice(end)}`;

      dinput.selectionStart = dinput.selectionEnd = start + text.length;
      this.formGroup.controls["DebitCommentFormat"].setValue(dinput.value);
      dinput.focus();
    } else {
      const value = cinput.value;

      const start = cinput.selectionStart;
      const end = cinput.selectionEnd;

      cinput.value = `${value.slice(0, start)}${text}${value.slice(end)}`;

      cinput.selectionStart = cinput.selectionEnd = start + text.length;
      this.formGroup.controls["CreditCommentFormat"].setValue(cinput.value);
      cinput.focus();
    }
  }

  wrap(text) {
    return `[${text}]`;
  }
  onChange(key: string) {
    this.currentSeletedColumnKey = key;
  }

  beforupdate() {
    if (
      this.formGroup &&
      this.InvVoucherKindId &&
      (!this.formGroup.controls["InvVoucherKindId"] || !this.formGroup.controls["InvVoucherKindId"].value)
    )
      this.setValue("InvVoucherKindId", this.InvVoucherKindId);
    if (
      this.formGroup &&
      this.TrsVoucherKindId &&
      (!this.formGroup.controls["TrsVoucherKindId"] || !this.formGroup.controls["TrsVoucherKindId"].value)
    )
      this.setValue("TrsVoucherKindId", this.TrsVoucherKindId);

    if (this.formGroup && this.formGroup.controls["DebitCommentFormat"])
      this.formGroup.controls["DebitCommentFormat"].setValue(this.replaceItemValues(this.formGroup.controls["DebitCommentFormat"].value));
    if (this.formGroup && this.formGroup.controls["CreditCommentFormat"])
      this.formGroup.controls["CreditCommentFormat"].setValue(this.replaceItemValues(this.formGroup.controls["CreditCommentFormat"].value));
  }
  deleteDetailComment() {
    this.httpCommonService
      .delete(this.apiName, this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (results) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
          this.currentrow = undefined;
          setTimeout(() => this.ngOnInit(), 200);
          this.cd.markForCheck();
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  delete() {
    this.sts.showDialog("آیا از حذف قابل شرح انتخاب شده اطمینان دارید؟", "حذف اطلاعات", DialogType.confirm, () => this.deleteDetailComment());
  }
}
